import { useAppConfigRedirect } from '@/context/AppConfig';
import { ValidReportTypes } from '@/utils/helperTypes';

export const useReportRedirect = () => {
  const { redirect, routingUtils } = useAppConfigRedirect();
  const {
    viewReportUrl,
    searchPersonUrl,
    searchPersonUrlv2,
    searchPersonByAddressUrl,
    searchPropertyListingsUrl,
    searchContactUrl,
    searchPropertyOptionsUrl,
    searchListUrl,
    searchObituaryUrl,
    location,
  } = routingUtils;

  function redirectToReportUrl(
    reportType: Parameters<typeof viewReportUrl>[0],
    reportPermalink: Parameters<typeof viewReportUrl>[1]
  ) {
    redirect(
      viewReportUrl(
        reportType.toLocaleLowerCase() as ValidReportTypes,
        reportPermalink
      )
    );
  }

  function redirectToSearchPersonUrl(
    searchTerm: Parameters<typeof searchPersonUrl>[0]
  ) {
    redirect(searchPersonUrl(searchTerm));
  }

  function redirectToSearchPersonUrlv2(
    searchTerm: Parameters<typeof searchPersonUrlv2>[0]
  ) {
    redirect(searchPersonUrlv2(searchTerm));
  }

  function redirectToSearchPersonByAddressUrl(
    searchTerm: Parameters<typeof searchPersonByAddressUrl>[0]
  ) {
    redirect(searchPersonByAddressUrl(searchTerm));
  }

  function redirectToSearchPropertyListingsUrl(
    searchTerm: Parameters<typeof searchPropertyListingsUrl>[0]
  ) {
    redirect(searchPropertyListingsUrl(searchTerm));
  }

  function redirectToSearchContactUrl(
    searchTerm: Parameters<typeof searchContactUrl>[0]
  ) {
    redirect(searchContactUrl(searchTerm));
  }

  function redirectToSearchPropertyOptionsUrl(
    searchTerm: Parameters<typeof searchPropertyOptionsUrl>[0]
  ) {
    redirect(searchPropertyOptionsUrl(searchTerm));
  }

  function redirectToListsUrl(searchTerm: Parameters<typeof searchListUrl>[0]) {
    redirect(searchListUrl(searchTerm));
  }

  function redirectToSearchObituaryUrl(
    searchTerm: Parameters<typeof searchObituaryUrl>[0]
  ) {
    redirect(searchObituaryUrl(searchTerm));
  }

  return {
    location,
    redirectToReportUrl,
    redirectToSearchPersonUrl,
    redirectToSearchPersonUrlv2,
    redirectToSearchPersonByAddressUrl,
    redirectToSearchPropertyListingsUrl,
    redirectToSearchContactUrl,
    redirectToSearchPropertyOptionsUrl,
    redirectToListsUrl,
    redirectToSearchObituaryUrl,
  } as const;
};

export default useReportRedirect;
